// extracted by mini-css-extract-plugin
export var content = "_5c-3";
export var list = "_5c-4";
export var settingsContent = "_5c-7";
export var settingsPanel = "_5c-8";
export var state = "_5c-6";
export var triggerBadge = "_5c-2";
export var triggerButton = "_5c-1";
export var triggerShell = "_5c-0";
export var unreadDot = "_5c-5";